<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销周报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="产品编码">
							    <el-input
							            v-model="q.proCode"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
							<el-form-item label="产品型号">
							    <el-input
							            v-model="q.proModel"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
							<el-form-item label="库存状态">
								<brselect
										category="kucun_status"
										:v="q.stockStatus"
										v-model="q.stockStatus"
										:multiple="true"
										collapseTags
										clearable>
								</brselect>
							</el-form-item>

							<el-form-item label="　预测单编号">
							    <el-input
							            v-model="q.id"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
						</div>	
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　　占用订单编号">
									    <el-input
									            v-model="q.orderId"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="型号属性">
									    <el-select v-model="q.protype"
									               placeholder="请选择"
									               clearable>
									        <el-option label="自产" value="自产"></el-option>
									        <el-option label="OEM" value="OEM"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="常规或改制">
									    <brselect
									            category="shifou_dingzhi"
									            :v="q.isSpecific"
									            v-model="q.isSpecific"
									            clearable>
									    </brselect>
									</el-form-item>
									<el-form-item label="产品大类">
									    <brselect
									            category="product_level"
									            :v="q.cpdlCode"
									            v-model="q.cpdlCode"
												:multiple="true"
												collapseTags
									            clearable>
									    </brselect>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="预测类型">
									    <el-select v-model="q.ycrcode" clearable placeholder="请选择">
									        <el-option
									                v-for="item in ycrlist"
									                :key="item.value"
									                :label="item.label"
									                :value="item.value">
									        </el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="　　是否需排产">
									    <el-select v-model="q.isDel"
									               placeholder="请选择"
									               clearable>
									        <el-option label="是" value="1"></el-option>
									        <el-option label="否" value="2"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="　　是否生成采购">
									    <el-select v-model="q.isCg"
									               placeholder="请选择"
									               clearable>
									        <el-option label="是" value="1"></el-option>
									        <el-option label="否" value="2"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="国家名称">
									    <brselectlazy placeholder="请选择"
									                  category="YLCountry_agent"
									                  :v="q.country"
													  v-model="q.country"
													  :multiple="true"
													  collapseTags
									                  clearable>
									    </brselectlazy>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="发货状态">
									    <el-select v-model="q.orderStatus"
									               placeholder="请选择"
									               clearable>
									        <el-option label="部分发货" value="部分发货"></el-option>
									        <el-option label="未发货" value="未发货"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="审核状态">
										<brselect
												category="report_zhuangt"
												:v="q.forecastStatus"
												v-model="q.forecastStatus"
												:multiple="true"
												collapseTags
												clearable>
										</brselect>
<!--									    <el-select v-model="q.forecastStatus" clearable placeholder="请选择">-->
<!--									        <el-option-->
<!--									                v-for="item in yctype"-->
<!--									                :key="item.value"-->
<!--									                :label="item.label"-->
<!--									                :value="item.value">-->
<!--									        </el-option>-->
<!--									    </el-select>-->
									</el-form-item>
									<el-form-item label="创建人">
										<el-input
												v-model="q.cuname"
												placeholder="请输入"
												clearable>
										</el-input>
									</el-form-item>
									<el-form-item label="　使用预测订单号">
										<el-input
												v-model="q.orderSap"
												placeholder="请输入"
												clearable>
										</el-input>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="创建周">
										<el-date-picker
												:clearable="true"
												v-model="q.cdateWeek"
												type="week"
												value-format="yyyy-MM-dd"
												format="yyyy 第 WW 周"
												placeholder="选择周">
										</el-date-picker>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                        <!-- <el-form-item class="h-formBtnOut" style="margin-left: 0.1rem;">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn" @click="resetData" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
                        </el-form-item> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            @selection-change="handleSelectionChange"
                            stripe
                            :border="true"
							max-height="500"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                fixed
								width="40"
								label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
								fixed
                                label="预测单编号"
                                width="160"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                label="国家名称"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="型号"
                                min-width="180"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.proModel}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="110"
                                label="产品编码"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                label="预测状态"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="schedulingStatus"
                                label="排产状态"
                                width="90"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="数量"
                                width="60"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.proNumber}}
									    </div>
									</template>
                        </el-table-column>
						<el-table-column
								prop="totalProduct"
								label="排产数量"
								width="90"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalProduct}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="useNumber"
                                label="可录单数量"
                                width="110"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.useNumber}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
                                :show-overflow-tooltip="true"
                                width="130"
                                label="使用库存数量">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.useInventory}}
									    </div>
									</template>
                        </el-table-column>
						<el-table-column
								prop="scDateB"
								label="生产时间"
								width="160"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.scDateB?scope.row.scDateB:'暂无数据'}}
							</template>
						</el-table-column>
						<el-table-column
								prop="scDateE"
								label="入库时间"
								width="160"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.scDateE?scope.row.scDateE:'暂无数据'}}
							</template>
						</el-table-column>
						<el-table-column
								prop="warehouse"
								label="库龄"
								width="80"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.warehouse}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="stockStatus"
                                width="90"
                                label="库存状态">
                            <template slot-scope="scope">
                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="cpdlCode"
								label="产品大类"
								min-width="100"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<dictname category="product_level"  :v="scope.row.cpdlCode"/>
							</template>
						</el-table-column>
						<el-table-column
								prop="protype"
								label="型号属性"
								width="90"
								:show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
								prop="passDate"
								label="审批通过时间"
								width="130"
								:show-overflow-tooltip="true">
						</el-table-column>
                        <el-table-column
                                prop="isSpecific"
                                width="110"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                label="改制大类"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificReq}}
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="specificReform"
								label="改制要求"
								width="180"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.specificReform}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="reformPriceRmb"
								:show-overflow-tooltip="true"
								width="120"
								label="单台加价(元)">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.reformPriceRmb}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="productId"
								label="生产订单号"
								width="120"
								:show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
								prop="totalFinish"
								label="下线数量"
								width="90"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalFinish}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注"
                                min-width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                label="预计交货期"
                                width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cgCode"
                                label="采购订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
						<el-table-column
								prop="cgStatus"
								label="采购订单状态"
								width="120"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<dictname category="cg_status"  :v="scope.row.cgStatus"/>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="orderId"
                                label="销售订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
						<el-table-column
								prop="orderSap"
								label="使用预测订单号"
								width="140"
								:show-overflow-tooltip="true">
						</el-table-column>
                        <el-table-column
                                prop="orderStatus"
                                label="销售订单状态"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="shipmentNum"
                                label="销售订单发货数量"
                                width="150"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.shipmentNum}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                width="100"
                                label="操作">
                            <template slot-scope="scope">
                                <div style="display: flex;align-items: center;justify-content: center;">
                                    <el-button
                                            @click="showRow(scope.row.id)"
                                            type="text"
                                            size="small" class="h-tableLink h-btn">查看占用
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="q" @query="handlelist" />
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="h-txtCenter h-mrt60" v-auth="'sdyc'">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="lockOrder">锁定预测</el-button>
            </div>-->
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                ycrlist: [{
                    value: 'my',
                    label: '我的预测'
                }, {
                    value: 'all',
                    label: '全部预测'
                }],
                yctype: [{
                    value: '2',
                    label: '待审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }, {
                    value: '5',
                    label: '撤单审核中'
                }, {
                    value: '6',
                    label: '已撤单'
                }, {
                    value: '7',
                    label: '修改审核中'
                }],
                multipleSelection: [],
                tableData: [],
                userRole: [],
                zcData: [],
                a: '',
				ro: '',
                loadFlag: '',
                q: {
					id: '',
					country: '',
					cdateWeek: '',
					isSpecific: '',
					forecastStatus: '',
					lockStatus: '',
					cpdlCode: '',
					proModel: '',
					proCode: '',
					cuname: '',
					ycrcode: '',
					protype: '',
					isDel: '',
					isCg: '',
					orderStatus: '',
					stockStatus:'',
					orderId: '',
					orderSap: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
            }
        },
        mounted() {

        },
        created() {
			if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('swyl_waixiaogly')) {
				this.ro = 1;
				this.q.stockStatus = '1';
			}
            this.query();
        },
		activated(){
			this.handleFilter();
		},
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = false;
			next();
		},
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            createOrder(ycid) {
                this.$router.push({path: '/dingd/orderCreate',query:{ycId:ycid}});
            },
            showRow(id) {
                this.$router.push({path: "/yuce/yuceOccupy", query: {id: id, status: 2}})
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            resetData() {
                this.q.id = '';
                this.q.country = '';
                this.q.cdateWeek = '';
                this.q.isSpecific = '';
                this.q.forecastStatus = '';
                this.q.lockStatus = '';
                this.q.cpdlCode = '';
                this.q.proModel = '';
                this.q.proCode = '';
                this.q.cuname = '';
                this.q.ycrcode = '';
                this.q.protype = '';
                this.q.isDel = '';
                this.q.isCg = '';
                this.q.orderStatus = '';
                this.q.orderId = '';
                this.q.orderSap = '';
                if (this.ro == 1) {
					this.q.stockStatus = '1';
				} else {
					this.q.stockStatus = '';
				}
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.query();
            },
            //明细导出
            exportExcel() {
                this.q.idlist=[];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.q.idlist.push(element.id);
                    })
                }
                updownfile.down("/api/swyl/v1/demo/viewWxycReport/downloadWeekExcel",this.q,"post",'data');
            },
            query() {
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_admin" || item.id == "swyl_waixiaogly") {
                        this.a = 0;
                        return;
                    }
                    if (item.id == "swyl_xiaoshoujl_wx") {
                        this.a = 1;
                    }
                })
                ss.waixiao.selectWeekPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectWeekList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            handleFilter() {
                this.q.pageNo = 1;
                ss.waixiao.selectWeekPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectWeekList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            handlelist() {
                ss.waixiao.selectWeekPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    // ss.waixiao.selectWeekList(this.q).then(rd => {
                    //     this.zcData = rd;
                    // })
                })
            },
            renovate() {
                this.$router.push({path:"/yuce/wxhuizong"});
            },
        }
    }
</script>
